import React from "react";
import styles from "./empty-ticket-container-tickets-page.module.scss";
import { SubTitle } from "@src/components/atoms/sub-title/sub-title";
import { FlexColumnContainer } from "@src/components/templates/layouts/flex-column-container/flex-column-container";
import { ContainerPanel } from "@src/components/organisms/container-panel/container-panel";
import { SubHeader } from "@src/components/atoms/sub-header/sub-header";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import { ContainerPane } from "@src/components/organisms/container-pane/container-pane";
import AutoTranslationButton from "@src/components/atoms/auto-translation-button/auto-translation-button";
import { useI18N } from "@src/language/language-context";

const cssClassName = "empty-ticket-container-tickets-page";

export default function EmptyTicketContainerTicketsPage() {
  const i18n = useI18N();

  const texts = {
    noTicketSelectedTitle: i18n(
      "modules.emptyTicketContainerTicketsPage.noTicketSelectedTitle",
    ),
    noTicketSelectedMessage: i18n(
      "modules.emptyTicketContainerTicketsPage.noTicketSelectedMessage",
    ),
  };
  return (
    <ContainerPanel>
      <SubHeader variant={"less-padding"}>
        <FlexRowContainer justifyContent="space-between">
          <span></span>
          <AutoTranslationButton
            ticketId={null}
            backgroundColor={"background"}
            disabled
          />
        </FlexRowContainer>
      </SubHeader>
      <ContainerPane>
        <div className={styles[cssClassName]}>
          <FlexColumnContainer verticalGap={12} alignItems="center">
            <SubTitle text={texts.noTicketSelectedTitle} />
            <p className={styles[`${cssClassName}__message`]}>
              {texts.noTicketSelectedMessage}
            </p>
          </FlexColumnContainer>
        </div>
      </ContainerPane>
    </ContainerPanel>
  );
}
